import { OwaDate, now, isBefore, differenceInDays } from 'owa-datetime';
import { getOwaDateFromDateString } from './getOwaDateFromDateString';
import { COUNT_DAYS_EXPIRED, COUNT_DAYS_NEW } from '../constants';

/**
 * This function get the finalDatePremiumDemo from options settings and returns how many days have left for premium preview
 * return -1 when the user didn't start their trial yet
 * return 0 when there are not any days left
 * return the actual number if the premium preview is active
 */
export function getDaysCountToPremiumPreviewExpired(
    finalDatePremiumDemo: string | undefined
): number {
    if (!finalDatePremiumDemo) {
        return COUNT_DAYS_NEW;
    }

    const endDate: OwaDate = getOwaDateFromDateString(finalDatePremiumDemo);
    if (isBefore(now(), endDate)) {
        const daysLeft = differenceInDays(endDate, now());
        return daysLeft + 1;
    }
    return COUNT_DAYS_EXPIRED;
}
